export default "__VITE_ASSET__ef1959cc__"